import { useState, useEffect } from "react";
import { handleInputChange, saveCondition, updateCondition } from "./utils";
import Emitter from "../../Common/emitterServices";
import {
  Editor,
  EditorProvider,
  Toolbar,
  BtnBold,
  BtnItalic,
  BtnUnderline,
  BtnLink,
  BtnUndo,
  BtnRedo,
  Separator
} from "react-simple-wysiwyg";

const AddConditions = () => {

    const [newCondition, setNewCondition] = useState("");
    const [emptyTextField, setEmptyTextField] = useState(false)
    const [isUpdate, setIsUpdate] = useState(false)
    const [conditionId, setConditionId] = useState("")

      useEffect(() => {
    const listener = (condition) => {
      setEmptyTextField(false);
      setNewCondition(condition.description);
      setIsUpdate(true);
      setConditionId(condition._id);
    };

    Emitter.on("update_condition", listener);

    // cleanup when component unmounts
    return () => {
      Emitter.off("update_condition", listener);
    };
  }, []);

    return (
        <div className={"add_terms_conditions_main"}>
            <div className={'add_terms_conditions_secondary'}>
                <div className="text_area_div">
                       <EditorProvider>
            <Editor
              value={newCondition}
              onChange={(e) =>  handleInputChange(e, setNewCondition, setEmptyTextField)}
              placeholder="Enter terms & conditions here..."
              style={{
                minHeight: "160px",
                borderRadius: "8px",
                backgroundColor: "#fff",
              }}
            >
              <Toolbar>
                <BtnBold />
                <BtnItalic />
                <BtnUnderline />
                <Separator />
                <BtnLink />
                <Separator />
                <BtnUndo />
                <BtnRedo />
                <Separator />
                    <button onClick={() =>
                        !isUpdate ?
                            saveCondition(newCondition, setNewCondition, setEmptyTextField)
                            :
                            updateCondition(newCondition, conditionId, setNewCondition,
                                setEmptyTextField, setIsUpdate)
                    }
                    className="submit-btn"
                    >
                        {!isUpdate ? "Submit" : "Update"}
                    </button>
              </Toolbar>
            </Editor>
          </EditorProvider>
                </div>
                
            </div>
        </div>
    )
}


export default AddConditions;